export const userAuthTypes = {
    SET_ACCOUNT_ID: 'SET_ACCOUNT_ID',
    SET_TOKEN: 'SET_TOKEN',
    IS_LOADING: 'IS_LOADING',
    SET_AUTH_DATA: 'SET_AUTH_DATA',
    SET_LAST_ORGANIZATION_ID_LOGGED: 'SET_LAST_ORGANIZATION_ID_LOGGED'
}